import {ONE_MINUTE_REFRESH_INTERVAL} from '../../../constants'
import {useUrlParam} from '../../useUrlParam'
import {usePlannerQuery} from '../usePlannerQuery'

export const useOptimizedSchedulesStatsQuery = () => {
  const plantCode = useUrlParam('plantCode')

  return usePlannerQuery('optimizedSchedulesStats', [{plantCode}], {
    refetchInterval: ONE_MINUTE_REFRESH_INTERVAL
  })
}
